import TiptapTable from '@tiptap/extension-table';

const Table = TiptapTable.configure({ resizable: true, lastColumnResizable: false });

export default Table;
